import axiosCommon from '@/axios-common/axios-common';
import InfiniteLoading from 'vue-infinite-loading';
import vSelect from 'vue-select';

export default {
    name: 'awpbDashboard',
    dependencies:['localeService'],
    components: {
        InfiniteLoading,
        vSelect
    },
    mounted() {
        this.initialize()
    },
    data() {
        return {
            awpbs: [],
            search: {
                months: '',
                years: '',
                keywords: ''
            },
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            years: [],
            skip: 0,
            take: 5
        }
    },
    methods: {
        initialize() {
            let vm = this;

            vm.initializeYears();

            return vm.getAWPBs()
                .then(function (res) {
                    if (res.data.length > 0) {
                        vm.awpbs = res.data;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        initializeYears() {
            let vm = this;
            let now = new Date();
            for (let year = now.getFullYear() ; year >= 1900 ; year--) {
                vm.years.push(String(year));
            }
        },
        infiniteHandler($state) {
            let vm = this;
            vm.skip += vm.take;
            vm.getAWPBs()
                .then(function (res) {
                    vm.awpbs = vm.awpbs.concat(res.data);
                    $state.loaded();
                    if (res.data && res.data.length == 0) {
                        $state.complete()
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });

        },
        filter() {
            let vm = this;
            vm.skip = 0;
            vm.take = 0;
            vm.getAWPBs()
                .then(function (res) {
                    vm.awpbs = res.data;
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        getAWPBs() {
            let vm = this;
            return axiosCommon.get(`o/awpbs?language=${vm.localeService.getCurrentLocale()}&skip=${vm.skip}&take=${vm.take}&months=${vm.search.months.toString()}&years=${vm.search.years.toString()}&keywords=${vm.search.keywords}`)
                .then(function (res) {
                    return res;
                })
                .catch(function (err) {
                    return err;
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/awpb-dashboard/awpb-dashboard.js